var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tabs",
    {
      staticClass: "git-settings",
      on: { change: _vm.onChangeTab },
      model: {
        value: _vm.activeTabName,
        callback: function($$v) {
          _vm.activeTabName = $$v
        },
        expression: "activeTabName"
      }
    },
    [
      _c(
        "el-tab-pane",
        { attrs: { label: _vm.$t("Settings"), name: "settings" } },
        [
          _c(
            "el-form",
            {
              ref: "git-settings-form",
              staticClass: "git-settings-form",
              attrs: { "label-width": "150px", model: _vm.spiderForm }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Git URL"),
                    prop: "git_url",
                    required: ""
                  }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("Git URL") },
                    on: { blur: _vm.onGitUrlChange },
                    model: {
                      value: _vm.spiderForm.git_url,
                      callback: function($$v) {
                        _vm.$set(_vm.spiderForm, "git_url", $$v)
                      },
                      expression: "spiderForm.git_url"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Has Credential"),
                    prop: "git_has_credential"
                  }
                },
                [
                  _c("el-switch", {
                    attrs: { size: "small", "active-color": "#67C23A" },
                    model: {
                      value: _vm.spiderForm.git_has_credential,
                      callback: function($$v) {
                        _vm.$set(_vm.spiderForm, "git_has_credential", $$v)
                      },
                      expression: "spiderForm.git_has_credential"
                    }
                  })
                ],
                1
              ),
              _vm.spiderForm.git_has_credential
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Git Username"),
                        prop: "git_username"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: _vm.$t("Git Username") },
                        on: { blur: _vm.onGitUrlChange },
                        model: {
                          value: _vm.spiderForm.git_username,
                          callback: function($$v) {
                            _vm.$set(_vm.spiderForm, "git_username", $$v)
                          },
                          expression: "spiderForm.git_username"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.spiderForm.git_has_credential
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Git Password"),
                        prop: "git_password"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("Git Password"),
                          type: "password"
                        },
                        on: { blur: _vm.onGitUrlChange },
                        model: {
                          value: _vm.spiderForm.git_password,
                          callback: function($$v) {
                            _vm.$set(_vm.spiderForm, "git_password", $$v)
                          },
                          expression: "spiderForm.git_password"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Git Branch"),
                    prop: "git_branch",
                    required: ""
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("Git Branch"),
                        disabled:
                          !_vm.spiderForm.git_url || _vm.isGitBranchesLoading
                      },
                      model: {
                        value: _vm.spiderForm.git_branch,
                        callback: function($$v) {
                          _vm.$set(_vm.spiderForm, "git_branch", $$v)
                        },
                        expression: "spiderForm.git_branch"
                      }
                    },
                    _vm._l(_vm.gitBranches, function(op) {
                      return _c("el-option", {
                        key: op,
                        attrs: { value: op, label: op }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("Auto Sync"), prop: "git_auto_sync" }
                },
                [
                  _c("el-switch", {
                    attrs: { size: "small", "active-color": "#67C23A" },
                    model: {
                      value: _vm.spiderForm.git_auto_sync,
                      callback: function($$v) {
                        _vm.$set(_vm.spiderForm, "git_auto_sync", $$v)
                      },
                      expression: "spiderForm.git_auto_sync"
                    }
                  })
                ],
                1
              ),
              _vm.spiderForm.git_auto_sync
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Sync Frequency"),
                        prop: "git_sync_frequency",
                        required: ""
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.$t("Sync Frequency") },
                          model: {
                            value: _vm.spiderForm.git_sync_frequency,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.spiderForm,
                                "git_sync_frequency",
                                $$v
                              )
                            },
                            expression: "spiderForm.git_sync_frequency"
                          }
                        },
                        _vm._l(_vm.syncFrequencies, function(op) {
                          return _c("el-option", {
                            key: op.value,
                            attrs: { value: op.value, label: op.label }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.spiderForm.git_sync_error
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Error Message"),
                        prop: "git_git_sync_error"
                      }
                    },
                    [
                      _c(
                        "el-alert",
                        { attrs: { type: "error", closable: false } },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.spiderForm.git_sync_error) + " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.sshPublicKey
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SSH Public Key") } },
                    [
                      _c(
                        "el-alert",
                        { attrs: { type: "info", closable: false } },
                        [_vm._v(" " + _vm._s(_vm.sshPublicKey) + " ")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "copy",
                          on: { click: _vm.copySshPublicKey }
                        },
                        [
                          _c("i", { staticClass: "el-icon-copy-document" }),
                          _vm._v(" " + _vm._s(_vm.$t("Copy")) + " ")
                        ]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: true,
                            expression: "true"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.sshPublicKey,
                            expression: "sshPublicKey"
                          }
                        ],
                        attrs: { id: "ssh-public-key" },
                        domProps: { value: _vm.sshPublicKey },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.sshPublicKey = $event.target.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "action-wrapper" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "warning",
                    disabled: _vm.isGitResetLoading,
                    icon: _vm.isGitResetLoading
                      ? "el-icon-loading"
                      : "el-icon-refresh-left"
                  },
                  on: { click: _vm.onReset }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Reset")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "danger",
                    icon: _vm.isGitSyncLoading
                      ? "el-icon-loading"
                      : "el-icon-refresh",
                    disabled: !_vm.spiderForm.git_url || _vm.isGitSyncLoading
                  },
                  on: { click: _vm.onSync }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Sync")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "success",
                    icon: "el-icon-check"
                  },
                  on: { click: _vm.onSave }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-tab-pane",
        { attrs: { label: "Log", name: "log" } },
        [
          _c(
            "el-timeline",
            { staticClass: "log" },
            _vm._l(_vm.commits, function(c) {
              return _c(
                "el-timeline-item",
                {
                  key: c.hash,
                  attrs: { timestamp: c.ts, type: _vm.getCommitType(c) }
                },
                [
                  _c("div", { staticClass: "commit" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "message" }, [
                        _vm._v(" " + _vm._s(c.message) + " ")
                      ]),
                      _c("div", { staticClass: "author" }, [
                        _vm._v(
                          " " + _vm._s(c.author) + " (" + _vm._s(c.email) + ") "
                        )
                      ])
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "row",
                        staticStyle: { "margin-top": "10px" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "tags" },
                          [
                            c.is_head
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "primary", size: "mini" } },
                                  [
                                    _c("i", { staticClass: "fa fa-tag" }),
                                    _vm._v(" HEAD ")
                                  ]
                                )
                              : _vm._e(),
                            _vm._l(c.branches, function(b) {
                              return _c(
                                "el-tag",
                                {
                                  key: b.name,
                                  attrs: {
                                    type:
                                      b.label === "master"
                                        ? "danger"
                                        : "warning",
                                    size: "mini"
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-tag" }),
                                  _vm._v(" " + _vm._s(b.label) + " ")
                                ]
                              )
                            }),
                            _vm._l(c.remote_branches, function(b) {
                              return _c(
                                "el-tag",
                                {
                                  key: b.name,
                                  attrs: { type: "info", size: "mini" }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-tag" }),
                                  _vm._v(" " + _vm._s(b.label) + " ")
                                ]
                              )
                            }),
                            _vm._l(c.tags, function(t) {
                              return _c(
                                "el-tag",
                                {
                                  key: t.name,
                                  attrs: { type: "success", size: "mini" }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-tag" }),
                                  _vm._v(" " + _vm._s(t.label) + " ")
                                ]
                              )
                            })
                          ],
                          2
                        ),
                        _c(
                          "div",
                          { staticClass: "actions" },
                          [
                            !c.is_head
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "danger",
                                      icon: _vm.isGitCheckoutLoading
                                        ? "el-icon-loading"
                                        : "el-icon-position",
                                      size: "mini"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.checkout(c)
                                      }
                                    }
                                  },
                                  [_vm._v(" Checkout ")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ]
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }